export const EXCEPTIONS = {
  NO_ENOUGH_CREDIT: 'Not enough credits for this action',
  DEVICE_ID_ALREADY_USED: 'deviceId: This value is already used.',
  EMAIL_ALREADY_USED: 'email: This value is already used.',
  EXISTING_CONVERSATION: 'customer: This value is already used.',
  INVALID_CREDENTIALS: 'Invalid credentials.',
  EXPERT_NOT_AVAILABLE: 'Expert is not available for the moment',
};
